import * as React from 'react';
import { AppPlatform, AutomationType } from '../../types';
import { isAndroidPlatform } from '../../helpers';
import Alert from 'antd/lib/alert';

interface AutomationConfigurationHelpBannerProps {
    automationType: AutomationType;
    appStoreDefaultsSet: boolean;
    stagedRolloutEnabled: boolean;
    platform: AppPlatform;
}

const AutomationConfigurationHelpBanner: React.FC<AutomationConfigurationHelpBannerProps> = (
    props: AutomationConfigurationHelpBannerProps,
) => {
    let banner = null;

    switch (props.automationType) {
        case AutomationType.AutoStagedRollout: {
            if (isAndroidPlatform(props.platform)) {
                const appSettingsAreOk = props.appStoreDefaultsSet && props.stagedRolloutEnabled;
                const appSettingsOkMessage = `Keep your App store defaults staged rollout option enabled to ensure that this automation can run.`;

                const appSettingsNotOkMessage =
                    !props.appStoreDefaultsSet ?
                        'Your default release method must be set to staged rollout in Runway for this automation to work. Configure your default release method in App settings > App store defaults > Release defaults.'
                    : !props.stagedRolloutEnabled ?
                        'Your default release method must be set to staged rollout in Runway for this automation to work. Go to App settings > App store defaults > Release defaults to update this setting.'
                    :   null;

                banner = (
                    <Alert
                        type={appSettingsAreOk ? 'success' : 'warning'}
                        message={appSettingsAreOk ? appSettingsOkMessage : appSettingsNotOkMessage}
                    />
                );
            }
        }
    }

    return banner;
};

export default AutomationConfigurationHelpBanner;
